import { render, staticRenderFns } from "./edit-assignment.html?vue&type=template&id=456b2640&scoped=true&"
import script from "./edit-assignment.js?vue&type=script&lang=js&"
export * from "./edit-assignment.js?vue&type=script&lang=js&"
import style0 from "./edit-assignment.css?vue&type=style&index=0&id=456b2640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b2640",
  null
  
)

export default component.exports